import styled from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Link = styled(CustomLink)`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.palette.primary.labels};
  background-color: ${({ theme }) => theme.palette.system.lightYellow};

  @media (hover: hover) {
    &:hover {
      background-color: #fff3d6;
    }
  }
`;

export const Text = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.primary.labels};
`;
